import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HeadersTool} from '../tools/headers';
import {FormGroup} from '@angular/forms';

export interface AffairQueryParams {
  selectedAgencies: string;
  selectedProducts: string;
  selectedProductsStatuses: string;
  search: string;
  size: number;
  page: number;
}

@Injectable({
  providedIn: 'root'
})

export class AffairesService {

  private route: string = '/affairs';

  constructor(
    private http: HttpClient
  ) { }

  public getAll(params: AffairQueryParams): Observable<any> {
    return this.http.post(`${environment.apiUrl}${this.route}/list`, params, {
      headers: HeadersTool.getHeadersWithToken(),
    })
  }

  public getOne(mlRef: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}${this.route}/${mlRef}`, {
      headers: HeadersTool.getHeadersWithToken(),
    })
  }

  public getAllFromLot(lotID: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/units-numbers/${lotID}/affairs/list`, {
      headers: HeadersTool.getHeadersWithToken(),
    })
  }

  public downloadDocument(url: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/file/download/${url}`, {
      headers: HeadersTool.getHeadersWithToken(),
    })
  }

  public getDownloadLink(url: string | undefined): string {
    return `${environment.apiUrl}/file/download/${url}`;
  }

  public appealAffaire(data: FormGroup): Observable<any> {
    return this.http.post(`${environment.apiUrl}${this.route}/make-conclusion-call`, data, {
      headers: HeadersTool.getHeadersWithToken(),
    })
  }



}
